import dataProvider from "src/dataProvider";

const fetcher = dataProvider("adminInstance");

export interface AdminQueryMessage {
  id: string;
  senderId: string;
  receiverId: string;
  message: string;
  isRead: boolean;
  createdAt: string;
  sender?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  receiver?: {
    id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

export const sendGcaReply = async (payload: { message: string }) => {
  return fetcher.post<
    typeof payload,
    { success: boolean; data: AdminQueryMessage }
  >("/admin-query/gca/send", payload);
};

export const getMyAdminQueries = async () => {
  return fetcher.get<{ success: boolean; data: AdminQueryMessage[] }>(
    "/admin-query/mine"
  );
};

export const getMyUnread = async () => {
  return fetcher.get<{ success: boolean; data: { count: number } }>(
    "/admin-query/unread"
  );
};
